import { environment } from "src/base/environment";

const md5 = require("md5");

/**
 * Generates an MD5 hash for a given key with a predefined suffix.
 */
export const GetHashed = (key: string): string => {
  if (!environment.IS_PRODUCTION) return key;
  return md5(key + "_Encrypted_with_MD5");
};